import { render, staticRenderFns } from "./BirthDateForm.vue?vue&type=template&id=bf593f96&scoped=true&"
import script from "./BirthDateForm.vue?vue&type=script&lang=js&"
export * from "./BirthDateForm.vue?vue&type=script&lang=js&"
import style0 from "./BirthDateForm.vue?vue&type=style&index=0&id=bf593f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf593f96",
  null
  
)

export default component.exports